import React from 'react';
import { useSelector } from 'react-redux';
import  corporation  from '../../assets/images/mine/corporation.png'
import { selectUserRequestsData } from '../../redux/apiSlices/requestSlice';

function Banner() {
  const { user } = useSelector(state => state.userState)
  const data = useSelector(selectUserRequestsData)
  return (
    <section class="pt-0">
	{/* <!-- Main banner background image --> */}
	<div class="container-fluid px-0">
		<div class="bg-blue h-100px h-md-200px rounded-0" style={{"background":"url(../../assets/images/pattern/04.png) no-repeat center center", "backgroundSize":"cover"}}>
		<div class="container position-relative">
		{/* <!-- SVG decoration START --> */}
		<figure class="position-absolute top-50 start-50 translate-middle ms-2">
			<svg>
				<path class="fill-white opacity-4" d="m496 22.999c0 10.493-8.506 18.999-18.999 18.999s-19-8.506-19-18.999 8.507-18.999 19-18.999 18.999 8.506 18.999 18.999z"/>
				<path class="fill-white opacity-4" d="m775 102.5c0 5.799-4.701 10.5-10.5 10.5-5.798 0-10.499-4.701-10.499-10.5 0-5.798 4.701-10.499 10.499-10.499 5.799 0 10.5 4.701 10.5 10.499z"/>
				<path class="fill-white opacity-4" d="m192 102c0 6.626-5.373 11.999-12 11.999s-11.999-5.373-11.999-11.999c0-6.628 5.372-12 11.999-12s12 5.372 12 12z"/>
				<path class="fill-white opacity-4" d="m20.499 10.25c0 5.66-4.589 10.249-10.25 10.249-5.66 0-10.249-4.589-10.249-10.249-0-5.661 4.589-10.25 10.249-10.25 5.661-0 10.25 4.589 10.25 10.25z"/>
			</svg>
		</figure>
		{/* <!-- SVG decoration END --> */}
		
		<div class="row">
			<div class="col-12">
					<div class="row position-relative">
						{/* <!-- Svg decoration --> */}
						<figure class="fill-white opacity-1 position-absolute top-50 start-0 translate-middle-y">
							<svg width="141px" height="141px">
								<path	d="M140.520,70.258 C140.520,109.064 109.062,140.519 70.258,140.519 C31.454,140.519 -0.004,109.064 -0.004,70.258 C-0.004,31.455 31.454,-0.003 70.258,-0.003 C109.062,-0.003 140.520,31.455 140.520,70.258 Z"/>
							</svg>
						</figure>

                        </div>
	
			</div>
            </div>
		{/*  <!-- Row END --> */}
	</div>
		</div>
	</div>
	<div class="container mt-n4">
		<div class="row">
		
			{/* <!-- Profile banner START --> */}
			<div class="col-12">
				<div class="card bg-transparent card-body p-0">
					<div class="row d-flex justify-content-between align-items-center">
						{/* <!-- Avatar --> */}
						<div class="col-auto mt-4 mt-md-0">
							<div class="avatar avatar-xxl mt-n3">
								<img class="avatar-img  border border-secondary border-3 shadow" src={user?.profile.logo ? user?.profile.logo : corporation} alt=""/>
							</div>
						</div>
						{/* <!-- Profile info --> */}
						<div class="col d-md-flex justify-content-between align-items-center mt-4">
							<div className='d-flex align-items-center my-1'>
								<h1 class="fs-4">
									{user?.name}
									{data?.verification_status === "verified" &&
									<i class="bi bi-patch-check-fill text-info small fs-4 mx-2"></i>
  									}
									</h1>
									
	
							</div>
						</div>
					</div>
				</div>
				{/* <!-- Profile banner END --> */}

				{/* <!-- Advanced filter responsive toggler START --> */}
				{/* <!-- Divider --> */}
				<hr class="d-xl-none"/>
				<div class="col-12 col-xl-3 d-flex justify-content-between align-items-center">
					<a class="h6 mb-0 fw-bold d-xl-none" href="#">الخيارات</a>
					<button class="btn btn-primary d-xl-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSidebar" aria-controls="offcanvasSidebar">
						<i class="fas fa-sliders-h"></i>
					</button>
				</div>
				{/* <!-- Advanced filter responsive toggler END --> */}
			</div>
		</div>
	</div>
</section>
  )
}

export default Banner